const ROLE_RANK = { guest: 1, member: 2, admin: 3 };
export function isKnownRole(role) {
    return role === "admin" || role === "member" || role === "guest";
}
/** Highest rank among the user's roles. admin > member > guest. */
export function highestRole(roles) {
    if (roles.includes("admin"))
        return "admin";
    if (roles.includes("member"))
        return "member";
    if (roles.includes("guest"))
        return "guest";
    return null;
}
export function roleSatisfies(userRoles, required) {
    const userMax = Math.max(0, ...userRoles.map((r) => ROLE_RANK[r] ?? 0));
    return userMax >= ROLE_RANK[required];
}
const MEMBER_DASHBOARDS = new Set(["calendar", "task-operations", "delivery-timeline"]);
/** Guest: Calendar only. Member: Calendar + Task Operations + Delivery Timeline. Admin: full catalog, including Team Load and Partner Load. */
export function canAccessDashboard(roles, dashboardId) {
    if (roleSatisfies(roles, "admin"))
        return true;
    if (roleSatisfies(roles, "member"))
        return MEMBER_DASHBOARDS.has(dashboardId);
    return roles.includes("guest") && dashboardId === "calendar";
}
export function isGuestOnly(roles) {
    return roles.includes("guest") && !roleSatisfies(roles, "member");
}
//# sourceMappingURL=auth.js.map